import tableAppTransactions from './tableAppTransactions';

export default {
  tabName: 'Succesful transactions',
  title: '',
  isTable: true,
  attributeName: 'appTransaction',
  getURL: 'appId/appTransactionPlay',
  updateURL: 'appId/appTransactionPlay',
  createURL: '',
  removeURL: 'appId/appTransactionPlay',
  sessionParams: ['appId'],
  noArea: true,
  tableConfig: tableAppTransactions,
  eventKey: 'successful',
  autoUpdate: true,
  updateValuesAfterUpdate: ['used'],
};
